import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import AuthProvider from './components/auth/AuthProvider';
import AuthGuard from './components/auth/AuthGuard';
import Router from './router';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import { ToastContainer, Bounce } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import GlobalProvider from './components/context/GlobalProvider';

const queryClient = new QueryClient();
const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <QueryClientProvider client={queryClient}>
      <GlobalProvider>
        <AuthProvider>
          <AuthGuard>
            <Router />
          </AuthGuard>
        </AuthProvider>
      </GlobalProvider>
      <ToastContainer
        position="top-right"
        autoClose={5000}
        hideProgressBar={false}
        newestOnTop={false}
        closeOnClick={false}
        rtl={false}
        pauseOnFocusLoss
        draggable
        pauseOnHover
        theme="light"
        transition={Bounce}
      />
    </QueryClientProvider>
  </React.StrictMode>,
);
